import React, {useState} from "react";
import uploadImageIcon from "../../../../../../assests/img/upload-image-icon.svg";
import {toast} from "react-toastify";
import {RemoveIcon} from "../../../../../../assests/GmsIcons";

interface UploadImageProps {
    id?: string;
    title?: string;
    launchIcon?: string;
    setFileParent: React.Dispatch<React.SetStateAction<File| null>>;
    onRemovePressed?: () => void
}

const UploadImage = ({id, launchIcon, setFileParent, onRemovePressed}: UploadImageProps) => {
    const baseId = id || 'upload-image';
    const [file, setFile] = useState(null);

    const handleFileChange = async (event: any) => {
        const selectedFile = event.target.files[0];
        const maxSize = 2 * 1024 * 1024;
        if (selectedFile) {
            if (selectedFile.size > maxSize) {
                toast.error('File size must be less than 2MB')
                return;
            }
            const validFormats = ["image/jpeg", "image/png", "image/gif", "image/webp"];
            if (!validFormats.includes(selectedFile.type)) {
                toast.error('Only image files (JPEG, PNG, GIF, WEBP) are allowed');
                setFile(null);
                setFileParent(null);
            } else {
                setFile(selectedFile);
                setFileParent(selectedFile);
            }
        }
    };

    return (
        <div id={baseId} data-testid={baseId} className="tw-w-full tw-px-[16px] tw-py-[14px] tw-bg-white tw-rounded tw-border tw-border tw-border-[#DADBDD] tw-justify-center tw-items-center tw-justify-between tw-items-center tw-inline-flex">
            <><input id={`${baseId}-input`} type="file"
                                accept="image/jpeg, image/png, image/gif, image/webp"
                                className="hidden" onChange={handleFileChange}/><label
                                id={`${baseId}-input-label`}
                                data-testid={`${baseId}-input-label`}
                                htmlFor={`${baseId}-input`}
                                className="popup-button-outline tw-pt-1"> Upload Image </label></>

            <div id={`${baseId}-preview`} className='tw-w-[164px] tw-justify-items-center'>
                <img id={`${baseId}-preview-image`} className="tw-object-cover tw-w-[164px]" src={file != null ? URL.createObjectURL(file) : (launchIcon ?? '').length > 0 ? launchIcon : uploadImageIcon} alt={'uploadImageIcon'}/>
                {file != null || (launchIcon ?? '').length > 0 ? <div id={`${baseId}-remove-btn`} data-testid={`${baseId}-remove-btn`} onClick={() => {
                                setFile(null);
                                setFileParent(null);
                                if (onRemovePressed) {
                                    onRemovePressed();
                                }
                            }}
                            className="tw-text-[#bf2600] tw-text-sm tw-font-normal tw-leading-tight tw-cursor-pointer tw-flex tw-items-center tw-pt-2"><RemoveIcon/>Remove Image</div> : null }
            </div>
    </div>
    );
}

export default UploadImage;